import { render, staticRenderFns } from "./application-franchise.vue?vue&type=template&id=276feed5&scoped=true"
import script from "./application-franchise.vue?vue&type=script&lang=ts"
export * from "./application-franchise.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276feed5",
  null
  
)

export default component.exports